import { combineReducers } from 'redux'
import {
  ADD_NOTE_LOCAL,
  ADD_NOTE_FULFILLED,
  GET_NOTE_FULFILLED,
  ADD_NOTE_LOCAL_CREATE,
  ADD_NOTE_LOCAL_CREATED
} from '../Actions/actions';


const updatedNotes = (state, action) => {
  return state.map((note) => {
    note.sync = true
    })
 }


/*
** TODO: Switch to for...in for better browser support
** Reference: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Statements/for...in
*/
const notesToArray = (notes) => {
  return Object.values(notes)
}

function appState(state = false, action) {
  switch (action.type) {
    case ADD_NOTE_LOCAL_CREATE:
      return {
        ...state,
        creating: true
      }
      case ADD_NOTE_LOCAL_CREATED:
        return {
          ...state,
          creating: false
        }
    default:
      return state
  }
}

function notes(state = {}, action) {
  switch (action.type) {
    case ADD_NOTE_LOCAL:
      return [
        ...state,
        {
          message: action.note.message,
          location: action.note.location,
          issue: action.note.issue,
          created: action.note.created,
          sync: false
        }
      ]
    case ADD_NOTE_FULFILLED:
      return [
        action.note
      ]
    case GET_NOTE_FULFILLED:
      return notesToArray(action.notes)
    default:
      return state
  }
}

const rootReducer = combineReducers({
  notes,
  appState
})

export default rootReducer



// WEBPACK FOOTER //
// ./src/Reducers/reducers.js